export default "__VITE_ASSET__C0mhM20g__"